export const CsvValidationError = {
    required: 1,
    invalidBoolean: 2,
    invalidNumberOfColumns: 3,
    invalidColumn: 4,
    invalidDomain: 5,
    invalidCountry: 6,
    invalidNumber: 7,
    invalidDate: 8,
};
export const CsvValidationErrorMessage = {
    [CsvValidationError.required]: 'Column is required',
    [CsvValidationError.invalidBoolean]: 'Invalid boolean (should be "yes" or "no")',
    [CsvValidationError.invalidNumberOfColumns]: 'Invalid number of columns',
    [CsvValidationError.invalidColumn]: 'Invalid column',
    [CsvValidationError.invalidDomain]: 'Invalid domain',
    [CsvValidationError.invalidCountry]: 'Invalid country',
    [CsvValidationError.invalidNumber]: 'Invalid number',
    [CsvValidationError.invalidDate]: 'Invalid date (should be MM/DD/YYYY)',
};
//# sourceMappingURL=error.js.map